module.exports = __webpack_public_path__ + "img/particle_motion_00092.79f42af9.png";